import { useMemo } from 'react'
import {
  IconButton,
  Inline,
  Icon,
  Hidden
} from '@leroy-merlin-br/backyard-react'
import { FilterOutline } from '@backyard-ui/icons'
import Cookies from 'js-cookie'

import { Breadcrumb } from 'site/Breadcrumb'
import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import * as S from './styled'
import { ShareButton } from '../ShareButton'

interface WrapperWebProps {
  isSearchResultPage: boolean
  apiDomain: string
  categoryId: string
}

const WrapperWeb = ({
  isSearchResultPage,
  apiDomain,
  categoryId
}: WrapperWebProps) => {
  const { toggleMobileFilter, query } = useAlgoliaContext()

  const isOnMobileApp = Cookies.get('is_on_mobile_app') || false
  const shouldRenderShareButton = !isOnMobileApp

  const nodes = useMemo(() => {
    if (isSearchResultPage) {
      return [
        {
          id: '1',
          name: 'Home',
          url: '/'
        },
        {
          id: '2',
          name: `Busca: ${query}`,
          url: window.location.href
        }
      ]
    }
  }, [isSearchResultPage, query])

  return (
    <S.Wrapper>
      <Breadcrumb categoryId={categoryId} basehost={apiDomain} nodes={nodes} />

      <Hidden when={['giga', 'tera']}>
        <Inline space="mega">
          {shouldRenderShareButton && <ShareButton />}
          <S.FilterButtonWrapper data-testid="filter-button-responsive">
            <IconButton
              variant="ghost"
              size="kilo"
              label="filtrar"
              onClick={toggleMobileFilter}
            >
              <Icon as={FilterOutline} />
            </IconButton>
          </S.FilterButtonWrapper>
        </Inline>
      </Hidden>
    </S.Wrapper>
  )
}

export default WrapperWeb
